import GeneralTracker from '../GeneralTracker';


export default class BuyTokenOverlayTracker extends GeneralTracker {
  STORAGE_KEY = 'buyTokensOverlayKey';
  CAPTURE_NAME = 'ui:buyTokenOverlay:interaction';
  VERSION = '1';

  setHandlers() {
    const service = this.getService();

    // the `open` and `close` events should be handled at modal level
    service.on('openBuyTokenOverlay', this.onOpen);
    service.on('closeBuyTokenOverlay', this.onClose);
    service.on('errorBuyTokenOverlay', this.onError);
    service.on('selectPackageOnBuyTokenOverlay', this.onSelectPackage);
    service.on('selectPaymentMethodOnBuyTokenOverlay', this.onSelectPaymentMethod);
    service.on('selectCryptoCurrencyOnBuyTokenOverlay', this.onSelectCryptoCurrency);
    service.on('clickContinueOnBuyTokenOverlay', this.onClickContinue);
  }

  onSelectPackage = (payload) => {
    const { selectedPackage } = payload;
    const { amount, currency, id, quantity, type } = selectedPackage;

    this.track({
      action: 'selectPackage',
      details: { amount, currency, id, quantity, type },
    });
  };

  onSelectPaymentMethod = (payload) => {
    this.track({
      action: 'selectPaymentMethod',
      details: payload,
    });
  };

  onSelectCryptoCurrency = (payload) => {
    this.track({
      action: 'selectCryptoCurrency',
      details: payload,
    });
  };

  onClickContinue = (payload) => {
    const { processorId, options, id, username } = payload;
    const { device, paymentType } = options;

    this.track({
      action: 'clickContinue',
      details: { processorId, device, paymentType, id, username },
    });
  };

  onOpen = (payload) => {
    this.track({
      action: 'open',
      details: payload,
    });
  };

  onClose = (payload) => {
    this.track({
      action: 'close',
      details: payload,
    });
  };

  onError = (payload) => {
    this.track({
      action: 'error',
      details: payload,
    });
  };

  parsePayload = (payload) => {
    const { action, details: payloadDetails, ...payloadOther } = payload;

    const trackPayload = {
      action: `${action}BuyTokenOverlay`,
      labels: {
        ...payloadDetails,
        other: payloadOther,
      },
    };

    return trackPayload;
  };

  track = (payload) => {
    const trackPayload = this.parsePayload(payload);

    super.track(trackPayload);
  };
}
